module.exports = __webpack_public_path__ + "images/feature/20150603_02-fcf87e4c5f37d907535ea3bd7237bc1d.png";